<template>
  <div class="kefu_v">
    <iframe :src="kefu_link" />
  </div>
</template>

<script>
  import Fetch from '../../utils/fetch'

  export default {
    name: 'Index',
    components: {},
    data() {
      return {
        kefu_link: '',
      }
    },
    created() {
      this.$parent.footer('user')
    },
    mounted() {
      this.start()
    },
    methods: {
      start() {
        //  window.location.href = 'https://t.me/B2B0101';
        Fetch('/index/webconfig', { type: 'web' }).then((res) => {
          console.log(res.data)
          window.open(res.data.kefu_link)
        })
        return
      },
    },
  }
</script>

<style lang="less" scoped>
  .kefu_v {
    position: fixed;
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;

    iframe {
      padding-bottom: 55px;
      width: 100%;
      height: 100%;
    }
  }
</style>
